/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardViewQuickFilterDTO } from './LeaderboardViewQuickFilterDTO';
import {
    LeaderboardViewQuickFilterDTOFromJSON,
    LeaderboardViewQuickFilterDTOFromJSONTyped,
    LeaderboardViewQuickFilterDTOToJSON,
} from './LeaderboardViewQuickFilterDTO';
import type { LeaderboardSortParamsDTO } from './LeaderboardSortParamsDTO';
import {
    LeaderboardSortParamsDTOFromJSON,
    LeaderboardSortParamsDTOFromJSONTyped,
    LeaderboardSortParamsDTOToJSON,
} from './LeaderboardSortParamsDTO';
import type { LeaderboardViewColumnListDTO } from './LeaderboardViewColumnListDTO';
import {
    LeaderboardViewColumnListDTOFromJSON,
    LeaderboardViewColumnListDTOFromJSONTyped,
    LeaderboardViewColumnListDTOToJSON,
} from './LeaderboardViewColumnListDTO';
import type { LeaderboardGroupParamsDTO } from './LeaderboardGroupParamsDTO';
import {
    LeaderboardGroupParamsDTOFromJSON,
    LeaderboardGroupParamsDTOFromJSONTyped,
    LeaderboardGroupParamsDTOToJSON,
} from './LeaderboardGroupParamsDTO';

/**
 * 
 * @export
 * @interface NewLeaderboardViewDTO
 */
export interface NewLeaderboardViewDTO {
    /**
     * 
     * @type {LeaderboardViewColumnListDTO}
     * @memberof NewLeaderboardViewDTO
     */
    columnList: LeaderboardViewColumnListDTO;
    /**
     * 
     * @type {boolean}
     * @memberof NewLeaderboardViewDTO
     */
    defaultView: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewLeaderboardViewDTO
     */
    experimentsOnly?: boolean;
    /**
     * 
     * @type {LeaderboardGroupParamsDTO}
     * @memberof NewLeaderboardViewDTO
     */
    groupOptions?: LeaderboardGroupParamsDTO;
    /**
     * 
     * @type {string}
     * @memberof NewLeaderboardViewDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NewLeaderboardViewDTO
     */
    nameSearchMode?: NewLeaderboardViewDTONameSearchModeEnum;
    /**
     * 
     * @type {string}
     * @memberof NewLeaderboardViewDTO
     */
    nameSearchQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof NewLeaderboardViewDTO
     */
    query?: string;
    /**
     * 
     * @type {LeaderboardViewQuickFilterDTO}
     * @memberof NewLeaderboardViewDTO
     */
    quickFilters?: LeaderboardViewQuickFilterDTO;
    /**
     * 
     * @type {boolean}
     * @memberof NewLeaderboardViewDTO
     */
    runsLineage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewLeaderboardViewDTO
     */
    showSelectedHiddenByFilter?: boolean;
    /**
     * 
     * @type {LeaderboardSortParamsDTO}
     * @memberof NewLeaderboardViewDTO
     */
    sortOptions: LeaderboardSortParamsDTO;
}


/**
 * @export
 */
export const NewLeaderboardViewDTONameSearchModeEnum = {
    Substring: 'substring',
    Regexp: 'regexp'
} as const;
export type NewLeaderboardViewDTONameSearchModeEnum = typeof NewLeaderboardViewDTONameSearchModeEnum[keyof typeof NewLeaderboardViewDTONameSearchModeEnum];


/**
 * Check if a given object implements the NewLeaderboardViewDTO interface.
 */
export function instanceOfNewLeaderboardViewDTO(value: object): value is NewLeaderboardViewDTO {
    if (!('columnList' in value) || value['columnList'] === undefined) return false;
    if (!('defaultView' in value) || value['defaultView'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('sortOptions' in value) || value['sortOptions'] === undefined) return false;
    return true;
}

export function NewLeaderboardViewDTOFromJSON(json: any): NewLeaderboardViewDTO {
    return NewLeaderboardViewDTOFromJSONTyped(json, false);
}

export function NewLeaderboardViewDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewLeaderboardViewDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'columnList': LeaderboardViewColumnListDTOFromJSON(json['columnList']),
        'defaultView': json['defaultView'],
        'experimentsOnly': json['experimentsOnly'] == null ? undefined : json['experimentsOnly'],
        'groupOptions': json['groupOptions'] == null ? undefined : LeaderboardGroupParamsDTOFromJSON(json['groupOptions']),
        'name': json['name'],
        'nameSearchMode': json['nameSearchMode'] == null ? undefined : json['nameSearchMode'],
        'nameSearchQuery': json['nameSearchQuery'] == null ? undefined : json['nameSearchQuery'],
        'query': json['query'] == null ? undefined : json['query'],
        'quickFilters': json['quickFilters'] == null ? undefined : LeaderboardViewQuickFilterDTOFromJSON(json['quickFilters']),
        'runsLineage': json['runsLineage'] == null ? undefined : json['runsLineage'],
        'showSelectedHiddenByFilter': json['showSelectedHiddenByFilter'] == null ? undefined : json['showSelectedHiddenByFilter'],
        'sortOptions': LeaderboardSortParamsDTOFromJSON(json['sortOptions']),
    };
}

export function NewLeaderboardViewDTOToJSON(value?: NewLeaderboardViewDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'columnList': LeaderboardViewColumnListDTOToJSON(value['columnList']),
        'defaultView': value['defaultView'],
        'experimentsOnly': value['experimentsOnly'],
        'groupOptions': LeaderboardGroupParamsDTOToJSON(value['groupOptions']),
        'name': value['name'],
        'nameSearchMode': value['nameSearchMode'],
        'nameSearchQuery': value['nameSearchQuery'],
        'query': value['query'],
        'quickFilters': LeaderboardViewQuickFilterDTOToJSON(value['quickFilters']),
        'runsLineage': value['runsLineage'],
        'showSelectedHiddenByFilter': value['showSelectedHiddenByFilter'],
        'sortOptions': LeaderboardSortParamsDTOToJSON(value['sortOptions']),
    };
}

